export const DEFAULT_ORDER_COLUMN = 'id';
export const DEFAULT_ORDER_DIRECTION = 'asc';
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_SEARCH = '';
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const SEARCH_INPUT_WIDTH = 400;

export enum ColumnKey {
    Id = 'id',
    Title = 'title',
    CreatedAt = 'created_at',
    UpdatedAt = 'updated_at',
    Description = 'description',
    Body = 'body',
    NickName = 'nickname',
    Name = 'name',
    Email = 'email',
    IsActive = 'is_active',
    Role = 'role',
    Actions = 'actions',
    ProjectsAndScriptsCounter = 'projects_and_scripts_counter',
    User = 'user',
    Properties = 'properties',
    Details = 'details',
    EventDescription = 'event_description',
    ProductId = 'product_id',
}

export enum UserRole {
    SuperAdmin = 'super_admin',
    Admin = 'admin',
    ScriptWriter = 'script_writer',
    Manager = 'manager',
    Guest = 'guest',
}

export const ColumnTitle = {
    [ColumnKey.Description]: 'Опис',
    [ColumnKey.Body]: 'Опис',
    [ColumnKey.NickName]: 'Нікнейм',
    [ColumnKey.Name]: 'Імʼя',
    [ColumnKey.Email]: 'Email',
    [ColumnKey.CreatedAt]: 'Створено',
    [ColumnKey.UpdatedAt]: 'Оновлено',
    [ColumnKey.IsActive]: 'Активність',
    [ColumnKey.Role]: 'Роль',
    [ColumnKey.Actions]: 'Дії',
    [ColumnKey.ProjectsAndScriptsCounter]: 'Проекти\u00A0та\u00A0скрипти',
    [ColumnKey.Title]: 'Назва',
    [ColumnKey.User]: 'Користувач',
    [ColumnKey.Properties]: 'Властивості',
    [ColumnKey.Details]: 'Деталі',
    [ColumnKey.EventDescription]: 'Дія',
} as const;

export const UserRoles = {
    [UserRole.SuperAdmin]: 'Супер адмін',
    [UserRole.Admin]: 'Адмін',
    [UserRole.ScriptWriter]: 'Скриптолог',
    [UserRole.Manager]: 'Менеджер',
    [UserRole.Guest]: 'Гість',
};
